import FocusTrap from 'focus-trap-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages as accessMessages } from '../../constants/AccessibilityConstants';
import * as KeyboardConstants from '../../constants/Keyboard';
import * as KeyboardUtils from '../../lib/Keyboard';
import ButtonT3 from '../lib/ButtonT3/ButtonT3';

import { ModalBody, ModalButtonRow, ModalContainer, ModalTitle, ModalXRow } from './Modal';

export default class extends React.Component {
  static propTypes = {
    title: PropTypes.node,
    body: PropTypes.node,
    onClose: PropTypes.func,
    buttons: PropTypes.arrayOf(PropTypes.element),
    hideXRow: PropTypes.bool,
    closeButtonText: PropTypes.node,
    isSubscriptionModal: PropTypes.bool,
    isNoMarginBody: PropTypes.bool,
    isLeftAlignedBody: PropTypes.bool,
    isWideModal: PropTypes.bool,
    isSmall: PropTypes.bool,
    shouldStackAndReverseButtons: PropTypes.bool,
    isDismissable: PropTypes.bool,
  };

  static defaultProps = {
    isDismissable: true,
  };

  componentDidMount() {
    if (this.props.isDismissable) {
      this.bindKeyboardEvents();
    }
  }

  handleEsc = () => {
    this.props.onClose && this.props.onClose();
  };

  bindKeyboardEvents = () => {
    KeyboardUtils.bindKey({
      keySet: KeyboardConstants.KeySetKeys.MODAL,
      key: KeyboardConstants.MousetrapKeys.ESC,
      handler: this.handleEsc,
    });
  };

  unbindKeyboardEvents = () => {
    KeyboardUtils.unBindKey({
      keySet: KeyboardConstants.KeySetKeys.MODAL,
      key: KeyboardConstants.MousetrapKeys.ESC,
    });
  };

  onDeactivate = () => {
    if (this.props.isDismissable) {
      this.unbindKeyboardEvents();
    }
  };

  render() {
    const {
      onClose,
      title,
      body,
      buttons,
      closeButtonText,
      hideXRow,
      isSubscriptionModal,
      isNoMarginBody,
      isLeftAlignedBody,
      isWideModal,
      isSmall,
      shouldStackAndReverseButtons,
    } = this.props;

    const focusTrapOptions = {
      escapeDeactivates: false,
      onDeactivate: this.onDeactivate,
    };

    let buttonsToRender = buttons || [];
    if (closeButtonText) {
      buttonsToRender = buttonsToRender.concat(
        <ButtonT3 onClick={this.props.onClose} isRightAligned={true}>
          {closeButtonText}
        </ButtonT3>,
      );
    }

    // We do want a margin if there are buttons below the body
    const hasButtonsToRender = buttonsToRender && buttonsToRender.length;
    let isNoMargin;
    let isNoMarginWithButtons;
    if (isNoMarginBody) {
      if (hasButtonsToRender) {
        isNoMarginWithButtons = true;
      } else {
        isNoMargin = true;
      }
    }

    return (
      <ModalContainer isWideModal={isWideModal} isSmall={isSmall}>
        <FocusTrap focusTrapOptions={focusTrapOptions}>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
          <p className='visuallyHidden' tabIndex='0'>
            <FormattedMessage {...accessMessages.menuTrapScreenReaderText} />
          </p>
          {hideXRow ? null : <ModalXRow onClose={onClose} />}
          {title ? (
            <ModalTitle isSubscriptionModal={isSubscriptionModal}>{title}</ModalTitle>
          ) : null}
          {body ? (
            <ModalBody
              isSubscriptionModal={isSubscriptionModal}
              isNoMargin={isNoMargin}
              isNoMarginWithButtons={isNoMarginWithButtons}
              isLeftAligned={isLeftAlignedBody}
            >
              {body}
            </ModalBody>
          ) : null}
          {hasButtonsToRender ? (
            <ModalButtonRow
              shouldStackAndReverseButtons={shouldStackAndReverseButtons}
              buttons={buttonsToRender}
            />
          ) : null}
        </FocusTrap>
      </ModalContainer>
    );
  }
}
